import $ from 'jquery';

const $document = $(document);

function flexSetOffsetHeight($el) {
  const $flex = $el.closest('.webform-flex');
  $flex.each(function (i, el) {
    el.setAttribute('data-offsetHeight', el.offsetHeight);
  });
}

$document.on('state:visible', function (e) {
  if (e.trigger) {
    Promise.resolve().then(() => {
      flexSetOffsetHeight($(e.target));
    });
  }
});

$document.on('state:disabled', function (e) {
  if (e.trigger) {
    Promise.resolve().then(() => {
      flexSetOffsetHeight($(e.target));
    });
  }
});
